import localForage from "localforage";
import { persistReducer, createMigrate } from "redux-persist";

//actions
import WeatherDataActions from "./WeatherData.actions";

//constants
import { CONFIG_MAP } from "Constants/Config";

//reducer
import WeatherDataReducer from "./WeatherData.reducer";

//sagas
import WeatherDataSagas from "./WeatherData.sagas";

const WeatherDataPersistConfig = {
	key: "WeatherData",
	storage: localForage.createInstance({ name: "AppWeatherData" }),
	timeout: null as unknown as undefined,
	blacklist: ['weatherData'],
	version: 0,
	migrate: createMigrate({
		0: (state) => state,
	}),
};

export const initializeWeatherData = (config: Record<keyof typeof CONFIG_MAP, boolean>) => {

	const modules: any = [];

	if (config[CONFIG_MAP.weatherdata]) {
		modules.push({
			id: "WeatherData",
			reducerMap: {
				WeatherData: persistReducer(WeatherDataPersistConfig, WeatherDataReducer),
				// WeatherData: WeatherDataReducer,
			},
			sagas: [WeatherDataSagas],
			initialActions: [WeatherDataActions.INITIATE.action()],
			finalActions: [WeatherDataActions.UNINITIATE.action()],
		});
	}

	return modules;
};
